export async function fetchAIUserList(sGlobal: any): Promise<any[]> {
    const defaultAddress = sGlobal && sGlobal.config ? sGlobal.config.host : '';
    const postUrl = `${defaultAddress}/api/agent/employees`;

    const response = await fetch(postUrl, {
        method: 'get',
        headers: {
            Authorization: `Bearer ${sGlobal.session.id}`,
            'Content-Type': 'application/json',
        },
    });

    if (!response.ok) {
        return [];
    }

    const data = await response.json();
    if (data && data.code === 0) {
        return data.data || [];
    } else if (data && data.message) {
        throw new Error(data.message);
    }
    return [];
}
